import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Container,
  CircularProgress,
  Button
} from '@mui/material';

const ClipboardSync = () => {
  const [clipboardContent, setClipboardContent] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const fetchClipboard = async () => {
    try {
      const response = await fetch('https://bluejims.com:5005/generic/clipboard');
      const text = await response.text();
      setClipboardContent(text);
    } catch (error) {
      console.error('Failed to fetch clipboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateClipboard = async () => {
    setSending(true);
    try {
      await fetch('https://bluejims.com:5005/generic/clipboard', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: String(inputValue)
      });
      setClipboardContent(inputValue);
    } catch (error) {
      console.error('Failed to update clipboard:', error);
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    fetchClipboard();
    const interval = setInterval(fetchClipboard, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Container maxWidth="md" style={{ marginTop: '3rem' }}>
      <Typography variant="h4" gutterBottom>
        Shared Clipboard
      </Typography>

      <Box marginBottom={3}>
        <TextField
          label="Enter or Paste Code"
          placeholder="Paste code or text snippet..."
          fullWidth
          multiline
          minRows={6}
          maxRows={20}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          InputProps={{
            style: { fontFamily: 'monospace' }
          }}
        />
        <Box marginTop={1} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={updateClipboard}
            disabled={sending}
          >
            {sending ? 'Sending...' : 'Send to Clipboard'}
          </Button>
        </Box>
      </Box>

      <Typography variant="h6" gutterBottom>
        Current Clipboard (Latest)
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : (
        <TextField
          fullWidth
          multiline
          minRows={6}
          value={clipboardContent}
          InputProps={{
            readOnly: true,
            style: { fontFamily: 'monospace', backgroundColor: '#f5f5f5' }
          }}
        />
      )}
    </Container>
  );
};

export default ClipboardSync;
